module.exports = __webpack_public_path__ + "static/media/SeeingSound_02.4f5105d6.JPG";